// extracted by mini-css-extract-plugin
module.exports = {"popUpBody__description":"DeletePopup_popUpBody__description__1X8ll","popUpBody__button":"DeletePopup_popUpBody__button__2JGaA"};